/*
  Builds URLs for assets stored on the Craft Cloud CDN.

  Craft Cloud serves assets from:
    <cdnBaseUrl>/<environmentId>/assets/<fs subpath>/<path>

  The environment ID differs per environment, so it can't be hardcoded. Both
  values are injected at build time by webpack.mix.js (see the DefinePlugin
  config there) from the CRAFT_CLOUD_* environment variables.

  If no environment ID is available the Cloud filesystem falls back to its
  local filesystem, which is mounted at @web/local-uploads/.
*/

const CDN_BASE_URL = process.env.CRAFT_CLOUD_CDN_BASE_URL || 'https://cdn.craft.cloud'
const ENVIRONMENT_ID = process.env.CRAFT_CLOUD_ENVIRONMENT_ID

const assetBaseUrl = ENVIRONMENT_ID
  ? `${CDN_BASE_URL.replace(/\/+$/, '')}/${ENVIRONMENT_ID}/assets/`
  : '/local-uploads/'

/*
  `path` is relative to the assets root, and starts with the filesystem's
  subpath — eg. 'logos/placeholderImage.png' or 'media/bcps_placeholder.jpg'.
*/
const assetUrl = path => `${assetBaseUrl}${String(path).replace(/^\/+/, '')}`

/*
  Fallback thumbnail for entries with no thumbnailImage. Note this is the
  untransformed original: Cloud transforms are signed, so a transform URL
  can't be built outside of Craft.
*/
const placeholderImage = assetUrl('logos/placeholderImage.png')

export { assetBaseUrl, assetUrl, placeholderImage }
